module.exports = __webpack_public_path__ + "img/illustrationicon-sb-ottoman-recliner-boutique.be1ddd2.svg";